import React, { useState, useLayoutEffect, useRef } from 'react'
import styled from 'styled-components'

const StyledHeaderLined = styled.h2`
  position: relative;
  display: inline-block;
  margin: 0 0 20px;
  padding: 0 20px 5px 0;
  font-size: 40px;
  font-weight: ${({ theme }) => theme.font.light};

  :after {
    position: absolute;
    top: 50%;
    left: 100%;
    width: ${({ isVisible }) => (isVisible ? '100vw' : '0')};
    height: 1px;
    background: ${({ theme }) => theme.colors.primary};
    content: '';
    transition: width 1.6s ease;
  }
`

const HeaderLined = ({ children }) => {
  const [elementVisible, setElementVisible] = useState(false)
  const inputEl = useRef(null)

  useLayoutEffect(() => {
    let topPosition = inputEl.current.getBoundingClientRect().top - 600

    typeof window !== 'undefined' &&
      window.addEventListener('scroll', function() {
        if (window.pageYOffset > topPosition) {
          setElementVisible(true)
        }
      })
  })

  return (
    <StyledHeaderLined ref={inputEl} isVisible={elementVisible}>
      {children}
    </StyledHeaderLined>
  )
}

export default HeaderLined
